import rpe from '@cached/rpe.json';
import ums from '@cached/um.json';
import trimps from '@cached/trimps.json';
import valutazioni from '@cached/valutazione_allenamento.json';
import percentuali from '@cached/percentuali.json';
import attivita from '@cached/attivita.json';
import sport from '@cached/sport.json';
import ruoli from '@cached/ruolo.json';
import tests from '@cached/tests.json';
import tipoTests from '@cached/tipo_tests.json';
import calendarioTipo from '@cached/calendario_tipo.json';
const constants = {}
/** unità di misura da database
* tabella: t_ana_um
*/
constants.FRONTPAGE = "index.php";

constants.UMS = ums.reduce((acc,el)=>{
    acc[el.codice] = el.id;
    return acc;
},{});

constants.CONVERSIONI = ums.reduce((acc,el)=>{
    acc[el.codice] = el.conversione;
    return acc;
},{});

constants.ZONE = {
  "REC": 15,
},

constants.RPE = rpe;
constants.TRIMPS = trimps;
constants.VALUTAZIONI = valutazioni;
constants.PERCENTUALI = percentuali;
constants.ATTIVITA = attivita;
constants.SPORT = sport;
constants.RUOLI = ruoli;
constants.TESTS = tests;
constants.TIPO_TESTS = tipoTests;
constants.CALENDARIO_TIPO = calendarioTipo;

constants.SPORT_ABILITATI = constants.SPORT.filter(el=>(+el.abilitato && +el.praticato)).map(el=>+el.id);

const sport_id = {};
constants.SPORT.forEach((el)=>{
    constants['ID_'+(el.codice.toUpperCase())] = +el.id;
    sport_id[el.codice] = +el.id;
});

constants.sport_id = sport_id;



constants.SUCCESS_FALSE = {
    success: false,
    status: 304
}

export {
    sport_id,
    constants as default};
